import React, { useState, useEffect, useRef } from "react";
import DataTable from "../../../../Components/UiComponents/DataTable";
import { Dialog } from "primereact/dialog";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearch";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import "react-toastify/dist/ReactToastify.css";

// Components
import SingleSelectElement from "../../../../Components/UiComponents/SingleSelectElement";
import ToastElement from "../../../../Components/UiComponents/ToastElement";

// Services
import { getCustomerControlField } from "../../../../Services/customerServices";
import Loader from "../../../../Components/UiComponents/Loader";
import { getAllUsers, exportUsageLog, getLogDetails } from "../../../../Services/userService";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';
import { verifyToken } from "../../../../Services/authService";

export default function UsageLog(props) {
  const [customerId, setCustomerId] = useState(null);
  const [branch, setBranch] = useState(null);
  const [username, setUsername] = useState(null);
  const [custmerReferenceData, setCustmerReferenceData] = useState([]);
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const toast = useRef(null);
  const [promptTabs, setPromptTabs] = useState([]);
  const toastRef = useRef();
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: -1,
    sortField: "last_login",
    sortOrder: -1,
  });
  const [handleSelectionFilter, setHandleSelectionFilter] = useState("All");
  const [whereclause, setWhereclause] = useState(null)
  const [loading, setLoading] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [viewLogModal, setViewLogModal] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [logDetails, setLogDetails] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0)
  const [showVideo, setShowVideo] = useState(false);
  const navigate = useNavigate()

  const filters = [
    { text: "All", value: "All" },
    { text: "More than 3 months ago", value: "More than 3 months ago" },
    { text: "Less than 3 months ago", value: "Less than 3 months ago" },
    { text: "Less than 2 months ago", value: "Less than 2 months ago" },
    { text: "Last month", value: "Last month" },
    { text: "Earlier this month", value: "Earlier this month" },
    { text: "3 weeks ago", value: "3 weeks ago" },
    { text: "2 weeks ago", value: "2 weeks ago" },
    { text: "Last week", value: "Last week" },
    { text: "This week", value: "This week" },
    { text: "Yesterday", value: "Yesterday" },
    { text: "Today", value: "Today" },
  ];

  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");
    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);
      // Extracting customer information from end user data
      const customer = enduser.customer;
      // Setting customer ID state
      setCustomerId(customer);
      setBranch(enduser.branch);
      setUsername(enduser.username);
    }else {
      navigate("/login")
      localStorage.clear()
    }
  }, []);

  useEffect(() => {
    // Fetching customer field data
    getCustomerField();

    // Fetching customer control data
    getCustomerControl();
  }, [customerId]);



  useEffect(() => {
    getCustomerField();
  }, [lazyParams, handleSelectionFilter]);

  // Function to fetch users log data from the server
  const getCustomerField = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true);
      // Ensure customerId is not nulll

      if (customerId !== null) {
        const { first, rows, sortField, sortOrder } = lazyParams;
        const skip = first;
        const limit = rows;
        const orderBy = sortOrder;
        const sortBy = sortField;
        const pattern = searchQuery || undefined;

        // Fetch customer data from the server
        const customerData = await getAllUsers(
          customerId,
          username,
          pattern,
          handleSelectionFilter,
          sortBy,
          orderBy,
          skip,
          limit,
          branch
        );
        // Set the reference data in the state
        setCustmerReferenceData(customerData?.data?.users);
        setTotalRecords(customerData?.data?.totalCount);
        setWhereclause(customerData?.data?.whereClause)

        if (customerData && customerData?.data.totalCount === 0) {
          setShowExport(false)
        } else {
          setShowExport(true)
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  // Function to fetch and set customer control fields data
  const getCustomerControl = async () => {
    try {
      if (customerId === null) {
        return;
      }
      // Check if customerId is available
      if (customerId !== null) {
        // Fetch customer control field data
        const customerData = await getCustomerControlField(customerId);
        // Extract and set customer control fields
        const controlFields = customerData?.data?.cust[0].modules[0];
        const promptTabs = controlFields.tabs.filter(
          (tab) => tab.tab_name === "Usage Log"
        );
        setPromptTabs(promptTabs[0].tables[0].headers);
        setCustomerControlFields(controlFields);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };
  const checkingFirstname = (rowData) => {
    return (
      <div>
        {
          <div>
            {rowData.firstname != null && rowData.firstname != ""
              ? rowData.firstname
              : rowData.firstname}
          </div>
        }
      </div>
    );
  };
  const checkingSurname = (rowData) => {
    return <div>{<div>{rowData.surname}</div>}</div>;
  };
  const checkingUsername = (rowData) => {
    return <div>{<div>{rowData.username}</div>}</div>;
  };
  const checkingRolename = (rowData) => {
    return <div>{<div>{rowData.role_name}</div>}</div>;
  };
  const last_login = (rowData) => {
    return <div>{<div>{rowData.last_login}</div>}</div>;
  };
  const last_logout = (rowData) => {
    return <div>{<div>{rowData.last_logout}</div>}</div>;
  };
  const login_attempts = (rowData) => {
    return <div className="form-label-text text-left mr-20 pointer mar-l-5">{rowData.login_attempts}</div>;
  };

  // Define column configuration for the data table
  const columns = [
    {
      field: "username",
      header: promptTabs[2]?.display_name ? promptTabs[2]?.display_name : "",
      body: checkingUsername,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "firstname", // Field name for the column data
      header: promptTabs[0]?.display_name ? promptTabs[0]?.display_name : "", // Header text displayed in the table header
      body: checkingFirstname, // Function to render the cell content for this column
      // style: { width: "30%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "surname",
      header: promptTabs[1]?.display_name ? promptTabs[1]?.display_name : "",
      body: checkingSurname,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },

    {
      field: "role_name",
      header: promptTabs[3]?.display_name ? promptTabs[3]?.display_name : "",
      body: checkingRolename,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "last_login",
      header: promptTabs[4]?.display_name ? promptTabs[4]?.display_name : "",
      body: last_login,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "last_logout",
      header: promptTabs[5]?.display_name ? promptTabs[5]?.display_name : "",
      body: last_logout,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "login_attempts",
      header: promptTabs[6]?.display_name ? promptTabs[6]?.display_name : "",
      body: login_attempts,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
  ];


  const resetFilter = () => {
    setHandleSelectionFilter("All");
  };


  const onPage = (event) => {
    setLazyParams({
      ...lazyParams,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e);
    setLazyParams({
      ...lazyParams,
      first: 0, // Reset to first page on new search
      page: 0
    });


  };
  const handleClearFilter = () => {
    setSearchQuery("");
    setLazyParams({
      ...lazyParams,
      first: 0, // Reset to first page on new search
      page: 0
    });


  };


  const exportExcel =async  () => {
    try {
      const isTokenValid = await verifyToken()
      if (isTokenValid.success) {
        exportUsageLog(JSON.stringify(whereclause), username);
      }
    }
    catch (error) {
      console.error("Error downloading file", error);
    }
  }

  const rowClick = async (data) => {
    try {
      if (data.login_attempts >= 0) {
        setViewLogModal(true)
        var logDetails = await getLogDetails(data.id)
        if (logDetails && logDetails.data) {
          var userDetails = logDetails.data.userDetails[0];
          setUserDetails(userDetails)
          setLogDetails(logDetails.data.logDetails);
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  }

  const handleHide = () => {
    setViewLogModal(false);
  };

  const renderFooter = () => {
    return (
      <div className="cancel-footer">
        <div className='align-center justify-end pb-0'>
          <ButtonElement label="Close" className="cancel-new-button" onClick={handleHide} />
        </div>
      </div>
    );
  };

  const onSort = (e) => {
    let newSortField = e.sortField;
    let newSortOrder = e.sortOrder;

    // Check if the same column is clicked
    if (lazyParams.sortField === newSortField) {
      // If currently sorted ascending, switch to descending
      if (lazyParams.sortOrder === 1) {
        newSortOrder = -1; // Set to descending
      }
      // If currently sorted descending, remove sorting
      else if (lazyParams.sortOrder === -1) {
        newSortField = 'last_login'; // Remove sorting
        newSortOrder = -1; // Remove sorting
      }
    }
    setLazyParams((prevParams) => ({
      ...prevParams,
      sortField: newSortField,
      sortOrder: newSortOrder,
    }));
  };

  const handleButtonClick = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
      setShowVideo(false);
  };

  return (
    <div className="group-table-component">
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <div className="header-design">
          <div>
              <p className="fs-16 fw-600 mar-b-3">{customerControlFields?.tabs[4].display_name}</p>
          </div>
          <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
      </div>
      <div className="group-table-buttons">
        <div className="delete-button" style={{ width: "200px" }}></div>
        <div className="group-table-search">
          <HeaderSearchBar
            value={searchQuery}
            onChange={(e) => handleSearchChange(e)}
            onClick={handleClearFilter}
          />
          <ButtonElement
            className="clear-filter-button"
            icon="pi pi-filter-slash"
            onClick={resetFilter}
          />
          <div className="col pr-0" >
            <SingleSelectElement
              value={handleSelectionFilter}
              optionLabel="text"
              options={(filters != undefined && filters.length > 0) ? filters : []}
              placeholder="-- Please select --"
              maxSelectedLabels={1}
              onChangeValue={(e) => setHandleSelectionFilter(e.value)}
              className="usage-filter"
            />

          </div>
          <ButtonElement
            className="clear-filter-button"
            type="button"
            icon="pi pi-file-export"
            onClick={() => exportExcel()}
            disabled={!showExport}
            tooltip='Export'
          />
        </div>
      </div>
      <DataTable
        value={custmerReferenceData}
        columns={columns}
        searchQuery={searchQuery}
        dataKey="_id"
        usageLog={true}
        totalRecords={totalRecords}
        rowClick={rowClick}
        onPage={onPage}
        lazyParams={lazyParams}
        onSort={onSort}

      />
      <div>
        <Dialog
          visible={viewLogModal}
          onHide={handleHide}
          className="width-50vw"
          header="User Log Details"
          position="right"
          footer={renderFooter}
          draggable={false}
        >
          <div className="new-field">
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left font-bold">First Name:</label>
              </div>
              <div className="col pr-0">
                <label className="form-label text-left">
                  {userDetails.firstname}
                </label>
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left font-bold">Surname:</label>
              </div>
              <div className="col pr-0">
                <label className="form-label text-left">
                  {userDetails.surname}
                </label>
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left font-bold">Username:</label>
              </div>
              <div className="col pr-0">
                <label className="form-label text-left">
                  {userDetails.username}
                </label>
              </div>
            </div>
            <div className="group-table-data">
              <table className="group-datatable usagelog">
                <thead className="group-table-header">
                  <tr>
                    <th colSpan={3}>Login Details</th>
                  </tr>
                  <tr>
                    <th className="width-10">#</th>
                    <th className="w-25">Login</th>
                    <th className="w-25">Logout</th>
                  </tr>
                </thead>
                <tbody className="group-table-row">
                  {
                    logDetails.length > 0 && logDetails.map((log, index) =>
                      <React.Fragment>
                        <tr>
                          <td className="width-10">
                            <label className="form-label text-left">{index + 1}</label>
                          </td>
                          <td className="w-25">
                            <label className="form-label text-left">{log.last_login}</label>
                          </td>
                          <td className="w-25">
                            <label className="form-label text-left">{log.last_logout}</label>
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </Dialog>
        <Dialog id="videoModal" visible={showVideo}
				breakpoints={{
				'1200px': '80vw',    // Larger modal on bigger screens
				'1024px': '85vw',    // Slightly smaller for medium screens
				'769': '90vw',     // Responsive on tablets
				'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
					<div className="video-container">
						<PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_usage_log" />
					</div>
				</div>
			</Dialog>

      </div>
    </div>
  );
}
